<template>
  <div>
    <b-navbar toggleable="sm" type="dark" variant="dark" class="dropShadow">
      <b-navbar-brand href="https://www.dropsar.com">
        <img src="https://s3.amazonaws.com/wox-drops/img/logo_116x116.png" height="30" alt="">
        <span class="font-weight-bold">DROPS</span>
        <span class="d-none d-md-inline" />
        <b-row class="d-md-none d-sm-block">
          <b-col />
        </b-row>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" />

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="isAuthenticated" class="ml-auto">
          <!-- <b-nav-item :href="'../' + $auth.user.username">{{
            $auth.user.username
          }}</b-nav-item> -->
          <b-nav-item to="/dashboard">
            <!-- {{ user.username }}'s  -->
            dashboard
          </b-nav-item>
          <b-nav-item :to="'/'+user.username_lower">
            public profile
          </b-nav-item>
          <b-nav-item to="/user/settings">
            settings
          </b-nav-item>
          <b-nav-item to="/logout">
            logout
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav v-else class="ml-auto">
          <b-nav-item v-b-modal.modal-1 class="my-auto" variant="dark">
            Subscribe to Mailing List
          </b-nav-item>
          <b-nav-item to="/login">
            <b-button variant="outline-dark">
              Login
            </b-button>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <MailchimpModal />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MailchimpModal from '~/components/landingPage/MailchimpModal'

export default {
  components: {
    MailchimpModal
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isAuthenticated']),
    isOnLogin () {
      return this.$route.path === '/login'
    }
  }
}
</script>

<style scoped>
.dropShadow {
  box-shadow: 0 2px 4px #fbeae9;
  -webkit-box-shadow: 0 2px 4px#FBEAE9;
  -moz-box-shadow: 0 2px 4px #fbeae9;
}
.headerText {
  font-size: 1.25rem;
}
</style>
